import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExpertDataService from "../../services/Expert";
import { BsPencil } from "react-icons/bs";
import { useDisclosure } from "@chakra-ui/react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { AddLeaveModal } from "../Modals/AddLeaveModal";
export const ExpertLeave = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  const [timing, setTiming] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleEvent = () => {
    fetchData();
  };
  
  const fetchData = async () => {
    ExpertDataService.getCalenderLeaveInfo(id)
      .then((res: any) => {
        const data = res.data.data;
        setTiming(data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  function formatDate(inputDate:any) {
    const parts = inputDate.split('-');
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate
  }

  const handleRemove = async (date: string) => {
    ExpertDataService.deleteCalenderLeaveInfo(id, formatDate(date))
      .then((res: any) => {
        fetchData();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="page_title py-2">Experts - App Experts</div>
      <div className="p-3">
        <div className="row m-0 mt-5 pt-3 justify-content-between align-items-center">
          <div className="col-sm-8 p-lg-0">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/eapp-expertsedit/${id}`)}
              >
                Edit
              </button>
            </div>
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/experts/view/${id}`)}
              >
                View
              </button>
            </div>
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/calender/${id}`)}
              >
                Calendar
              </button>
            </div>
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("AddLeave");
                  onOpen();
                }}
              >
                Add New Leave
              </button>
            </div>
          </div>
        </div>
        <div className="centered-container">
          {timing && (
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th className="time-slots">Time-slots</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {timing.map(({ date, timings }: any, i) => {
                  return (
                    <tr key={i}>
                      <td>{date}</td>
                      <td>
                        {timings.length > 0
                          ? timings
                              .map(
                                (item: { start: any; end: any }) =>
                                  `${item.start}-${item.end}`
                              )
                              .join(", ")
                          : "No slots available"}
                      </td>
                      <td>
                        <div className="table-icon pointer">
                          <MdOutlineDeleteForever
                            className="deleteButton pointer"
                            onClick={() => handleRemove(date)}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {modal === "AddLeave" && (
          <AddLeaveModal
            isOpen={isOpen}
            onClose={onClose}
            func={handleEvent}
            id={id}
          />
        )}
      </div>
    </>
  );
};
